import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title = "Atelier Persopol - AI Art & Custom Home Decor",
  description = "Transform your favorite photos into stunning painted masterpieces with Atelier Persopol. Create unique custom canvas prints, framed art, and home decor from your memories.",
  keywords = "AI art, photo to painting, portrait, AI art printing, custom home decor, canvas prints, Atelier Persopol, AI masterpiece, artistic style transfer, custom wall art",
  image = "/assets/process/combined.jpg",
  url = "https://atelier-persopol.com/",
  type = "website",
}) => {
  const siteTitle = title === "Atelier Persopol - AI Art & Custom Home Decor" ? title : `${title} | Atelier Persopol`;

  return (
    <Helmet>
      {/* Standard metadata */}
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={siteTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};

